module.exports = __webpack_public_path__ + "img/david.ab1c08b0.webp";